import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import Datetime from 'react-datetime';
import "moment/locale/en-gb";
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import { saveAs } from 'file-saver';
import "react-datetime/css/react-datetime.css";
import QRCode from 'qrcode';

moment.updateLocale("en-gb", {
    week: {
        dow: 1,
    },
});

const UpdateContact = (props) => {

    const { updateContract, maxSerialNumber, tab, isNewContract, openModal, setNewContractAdded } = props;
    const [contract, setContract] = useState(updateContract || {});
    const [disableSaveButton, setDisableSaveButton] = useState(false);
    const [date, setDate] = useState(updateContract?.date || moment().format("DD.MM.YYYY"));

    useEffect(() => {
        if (!updateContract) return;

        const initialDate = updateContract.date || moment().format("DD.MM.YYYY");
        setDate(initialDate);
        setContract({
            ...updateContract,
            size: updateContract.size || '',
            company_name: updateContract.company_name || '',
            vessel_name: updateContract.vessel_name || '',
            date: moment(initialDate, "DD.MM.YYYY").format("DD.MM.YYYY"),
        });
    }, [updateContract]);

    useEffect(() => {
        setContract((prev) => ({
            ...prev,
            date: moment(date, "DD.MM.YYYY").format("DD.MM.YYYY"),
        }));
    }, [date]);

    const handleClickedUpdateContract = async () => {
        const { date, serial_number, size } = contract;

        const fileName = simplifyKey(`Firemans_Outfit_Doc_${serial_number}_${size}.pdf`);

        await modifyPdf({ ...contract, file_name: simplifyKey(fileName) }, tab);
    };

    async function modifyPdf(contract, tab) {
        setDisableSaveButton(true);

        const { serial_number, length, ship_name, size, company_name, vessel_name, date, file_name } = contract;

        const url = `${process.env.REACT_APP_BACKEND_UPLOAD_LOCATION}/empty/${tab.type}.pdf`;
        const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());

        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        pdfDoc.registerFontkit(fontkit);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];

        const { width, height } = firstPage.getSize();

        const fontUrl = '/fonts/DejaVuSans-Bold.ttf';
        const dejavuSansBoldBuffer = await fetch(fontUrl).then(res => res.arrayBuffer());
        if (!dejavuSansBoldBuffer) {
            console.error("Failed to load DejaVuSans-Bold font buffer");
            return;
        }
        const dejavuSansBold = await pdfDoc.embedFont(dejavuSansBoldBuffer);

        switch (tab.type) {
            case 'firemans_outfit_contracts':
                firstPage.drawText(`${date}`, {
                    x: 175,
                    y: height - 710,
                    size: 10,
                    font: dejavuSansBold,
                    color: rgb(0, 0, 0),
                });

                firstPage.drawText(`${serial_number}`, {
                    x: 170,
                    y: height - 567,
                    size: 10,
                    font: dejavuSansBold,
                    color: rgb(0, 0, 0),
                });
                break;
            default:
                console.error("Unknown contract type");
                return;
        }

        const qrUrl = await createPresignedUrl(file_name);
        const qrCodeDataUrl = await QRCode.toDataURL(qrUrl);
        const qrImage = await pdfDoc.embedPng(qrCodeDataUrl);
        const qrWidth = 80;
        const qrHeight = 80;

        // 6. QR kodunu PDF'in sol üst köşesine ekleyin
        firstPage.drawImage(qrImage, {
            x: 20,
            y: height - qrHeight - 10,
            width: qrWidth,
            height: qrHeight,
        });


        const pdfBytes = await pdfDoc.save();
        const formData = new FormData();
        formData.append("file", new Blob([pdfBytes], { type: "application/pdf" }), file_name);
        formData.append("fileName", file_name);
        formData.append("contractData", JSON.stringify({
            id: isNewContract ? null : contract.id,
            length,
            ship_name: ship_name,
            size,
            company_name,
            vessel_name,
            date,
            file_name: file_name,
            url: qrUrl,
            serial_number: serial_number,
            contract_type: tab.type,
        }));

        const updateUrl = isNewContract ? `${process.env.REACT_APP_BACKEND_URL}/createContract` : `${process.env.REACT_APP_BACKEND_URL}/updateContract`;
        const response = await fetch(updateUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error('Failed to upload PDF');
        }

        saveAs(new Blob([pdfBytes]), file_name);
        openModal(false)
        setDisableSaveButton(false);
        setNewContractAdded(true);
    }

    function simplifyKey(filename) {
        const charMap = {
            'ı': 'i',
            'İ': 'I',
            'ö': 'o',
            'Ö': 'O',
            'ü': 'u',
            'Ü': 'U',
            'ş': 's',
            'Ş': 'S',
            'ç': 'c',
            'Ç': 'C',
            'ğ': 'g',
            'Ğ': 'G',
            ' ': '_',  // Replace spaces with underscores
        };

        // Use the map to replace characters in the filename
        const cleanedFilename = filename
            .split('')
            .map(char => charMap[char] || char)  // Replace if in the map, otherwise keep the original character
            .join('')
            .replace(/[^a-zA-Z0-9._-]/g, '_'); // Replace remaining special characters with underscores

        return cleanedFilename;
    }

    function createPresignedUrl(fileName) {
        return `${process.env.REACT_APP_BACKEND_URL}/certifications/pdf/${fileName}`;
    }

    return (
        <div className='absolute top-0 right-0 flex flex-col w-[100%] overflow-hidden h-[100vh] backdrop-blur-md flex justify-center items-center'>
            <div className='w-full md:w-[30%]  text-right '>

                <button
                    onClick={() => openModal(false)}
                    type="button"
                    className="m-2 rounded bg-red-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                >

                    <svg className='w-6 h-6' viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6M6 6l12 12" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>

                </button>
            </div>

            <div className='w-full p-3 bg-white items-center justify-center md:w-[30%] rounded-md border-2'>
                <div className='m-2'>
                    <label htmlFor="contract_id" className="block text-sm font-medium leading-6 text-gray-900">
                        Date
                    </label>
                    <div className="">
                        <Datetime value={contract.date} onChange={(date) => { setDate(moment(date).format("DD.MM.YYYY")) }} locale="en-gb" timeFormat={false} dateFormat={"DD.MM.yyyy"} initialValue={new Date()} className="border block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 " />
                    </div>
                </div>
                <div className='m-2'>
                    <label htmlFor="contract_id" className="block text-sm font-medium leading-6 text-gray-900">
                        Serial Number
                    </label>
                    <div>
                        <input
                            id="serial_number"
                            name="text"
                            type="text"
                            disabled={!isNewContract}
                            placeholder={"24"}
                            onChange={(e) => setContract({ ...contract, serial_number: e.target.value })}
                            value={contract.serial_number}
                            className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>

                <div className='m-2'>
                    <label htmlFor="size" className="block text-sm font-medium leading-6 text-gray-900">
                        Size
                    </label>
                    <div>
                        <input
                            id="size"
                            name="text"
                            type="text"
                            placeholder={"L / XL"}
                            value={contract.size}
                            onChange={(e) => setContract({ ...contract, size: e.target.value })}
                            className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>


                <div className='m-2'>
                    <label htmlFor="contract_id" className="block text-sm font-medium leading-6 text-gray-900">
                        Company Name
                    </label>
                    <div>
                        <input
                            id="company_name"
                            name="text"
                            type="text"
                            placeholder={"Company Name"}
                            onChange={(e) => setContract({ ...contract, company_name: e.target.value })}
                            value={contract.company_name}
                            className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>

                <div className='m-2'>
                    <label htmlFor="contract_id" className="block text-sm font-medium leading-6 text-gray-900">
                        Vessel Name
                    </label>
                    <div>
                        <input
                            id="vessel_name"
                            name="text"
                            type="text"
                            placeholder={"Vessel Name"}
                            onChange={(e) => setContract({ ...contract, vessel_name: e.target.value })}
                            value={contract.vessel_name}
                            className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>

                <div className='m-2'>
                    <label htmlFor="contract_type" className="block text-sm font-medium leading-6 text-gray-900">
                        Contract Type
                    </label>
                    <div>
                        <input
                            id="contract_type"
                            name="text"
                            type="text"
                            value={tab.name}
                            disabled={true}
                            placeholder=""
                            className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                    </div>
                </div>

                <button
                    onClick={handleClickedUpdateContract}
                    type="button"
                    disabled={disableSaveButton}
                    className="m-2 rounded bg-indigo-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                    {isNewContract ? <span>Create Contract</span> : <span>Update Contract</span>}
                </button>
            </div>
        </div>

    )
}

export default UpdateContact;